module.exports = __webpack_public_path__ + "img/p1.20036eda.png";